import { render, staticRenderFns } from "./fileInfo.vue?vue&type=template&id=3e4921c4&scoped=true&"
import script from "./fileInfo.vue?vue&type=script&lang=js&"
export * from "./fileInfo.vue?vue&type=script&lang=js&"
import style0 from "./fileInfo.vue?vue&type=style&index=0&id=3e4921c4&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4921c4",
  null
  
)

export default component.exports